export default {
  API: "https://prod.legacy.api.oatas.co/upstream/",
  AuthAPI: "https://prod.legacy.api.oatas.co/upstream/",
};
